<template>
  <div class="checkout-login details-container"
      :class="{ 'details-containerTs': data.brandNameFormatted === Brand.Travelsphere }">
    <h3 class="details-container__header"
    :class="{ 'details-container__headerTs': data.brandNameFormatted === Brand.Travelsphere }">{{data.login.title}}</h3>
    <div class="details-container__body">
      <div class="details-container__body-intro" v-html="data.login.descriptionHtml"></div>
      <Login v-if="isLoginForm" :data="data.login" @loginSuccess="loginSuccess"></Login>

      <div :class="{ 'd-flex justify-content-center flex-md-row': data.brandNameFormatted === Brand.Travelsphere,
                      'all-unset': isLoginForm && data.brandNameFormatted == Brand.Travelsphere
                   }">

        <button v-if="!isLoginForm" class="btn" @click="login" :class="{ 'mr-lg-10': data.brandNameFormatted === Brand.Travelsphere }" aria-label="Log in" title="Click to log in">Log in</button>
  
        <button :class="{
              'btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs': !isLoginForm && data.brandNameFormatted === Brand.Travelsphere,
              'link link-spacer': data.brandNameFormatted !== Brand.Travelsphere || isLoginForm
            }"
            @click="skipLogin" 
            aria-label="Continue without log in"
            title="Continue without log in">
          {{ data.brandNameFormatted === Brand.Travelsphere ? 'Continue' : 'Continue without log in' }}
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Login from '@/vue/components/Login/Login.vue';
import {Brand} from './../../../../brand.js';

export default {
  data() {
    return {
      Brand,
      isLoginForm: false
    };
  },

  components: {
    Login
  },

  computed: mapState('checkout', ['data']),

  methods: {
    login() {
      this.isLoginForm = true;
    },

    loginSuccess(response) {
      console.log(response);

      this.$store.dispatch('checkout/generateToken').then(() => {
        this.$store.dispatch('checkout/getLoggedInPassengerData').then(() => {
          this.$store.commit('checkout/setIsLoginBoxDisplayed', false);
        });
      });
    },

    skipLogin() {
      this.$store.commit('checkout/setIsLoginBoxDisplayed', false);
    }
  }
};
</script>